import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=039453ec&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=039453ec&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=039453ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039453ec",
  null
  
)

export default component.exports